import Error from '../model/Error';
import axios from 'axios';

export default class ClubTransactionInvoiceRepository {

    static create(clubTransactionId, clubInvoiceId) {
        const data = { clubTransactionId: clubTransactionId, clubInvoiceId: clubInvoiceId };
        return new Promise((resolve, reject) => {
            axios
                .post('/club/club-transaction-invoices', data)
                .then(response => resolve(response.headers['x-identifier']))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static deleteById(clubTransactionId) {
        return new Promise((resolve, reject) => {
            axios
                .delete('/club/club-transaction-invoices/' + clubTransactionId)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

}
